import React from "react";
import styled from "styled-components";

export const inputWithFloatingLabel = (Component) => (props) => {
  return (
    <Container>
      <Component {...props} />
      <LabelStyle value={props.value} htmlFor={props.id} title={props.title}>
        {props.label}
      </LabelStyle>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;

  textarea:focus ~ label,
  input:focus ~ label {
    top: -18px;
    font-size: x-small;
    background-color: #fff;
    padding: 2px 5px;
    left: -5px;
  }
`;
const isNullOrEmpty = (value) =>
  value === null ? true : value === "" ? true : false;
const LabelStyle = styled.label`
  position: absolute;
  transition: 100ms linear;
  color: gray;
  cursor: text;
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;

  font-size: ${(props) => (isNullOrEmpty(props.value) ? "smaller" : "x-small")};
  top: ${(props) => (isNullOrEmpty(props.value) ? "4px" : "-14px")};
  background-color: ${(props) =>
    isNullOrEmpty(props.value) ? "unset" : "#fff"};
  padding: ${(props) => (isNullOrEmpty(props.value) ? "0" : "0px 5px")};
  left: ${(props) => (isNullOrEmpty(props.value) ? "0" : "-5px")};
`;
